module.exports = __webpack_public_path__ + "static/img/9bg_6.c118d8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_6.png
// module id = 778
// module chunks = 1